<div class="banner" role="banner">
  <div class="container d-flex align-items-center">
    <h1 class="font-page-heading title fw-light-bold">{{ title }}</h1>
  </div>
</div>
